import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Calendar, User } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import api from "../lib/api.ts";
import NotificationBar from "../components/home/NotifictionBar";

const InformationPage = () => {
  const { slug } = useParams();
  const { language, translate } = useLanguage();
  const isRTL = language === "ar";

  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch content based on slug
  const fetchContent = async () => {
    if (!slug) return;

    setIsLoading(true);
    setError(null);

    try {
      const response = await api.get(`/pagesettings/${slug}`);
      const data = response.data;

      // Handle different slug responses (why-choose-us, about-us, etc.)
      const slugKey = slug.replace(/-/g, "_");
      const pageData = data[slugKey] || data.dynamic_content || data.data || data;
      const contentData = Array.isArray(pageData) ? pageData[0] : pageData;

      console.log("API Response:", data);
      console.log("Content Data:", contentData);

      if (contentData) {
        setContent(contentData);
      } else {
        setError("Content not found");
      }
    } catch (error) {
      console.error("Error fetching content:", error);
      setError("Failed to load content");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, [slug]);

  if (isLoading) {
    return (
      <div
        className='min-h-screen bg-gray-50 flex items-center justify-center'
        dir={isRTL ? "rtl" : "ltr"}
        lang={language}
      >
        <div className='text-center'>
          <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600 mx-auto mb-4'></div>
          <p className='text-gray-600'>
            {translate("common.loading") || "Loading..."}
          </p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className='min-h-screen bg-gray-50 flex items-center justify-center'
        dir={isRTL ? "rtl" : "ltr"}
        lang={language}
      >
        <div className='text-center max-w-md mx-auto px-4'>
          <div className='bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4'>
            <p className='font-medium'>
              {translate("common.error") || "Error"}
            </p>
            <p className='text-sm'>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!content) {
    return (
      <div
        className='min-h-screen bg-gray-50 flex items-center justify-center'
        dir={isRTL ? "rtl" : "ltr"}
        lang={language}
      >
        <div className='text-center'>
          <p className='text-gray-600'>
            {translate("common.notFound") || "Content not found"}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className='min-h-screen '
      dir={isRTL ? "rtl" : "ltr"}
      lang={language}
    >
      {/* Notification Bar */}
      {/* <NotificationBar /> */}
      {/* <style>{`
        .blog-content .ql-ui { display: none; }
        .blog-content ol { list-style: decimal; margin-left: 1.25rem; }
        .blog-content ul { list-style: disc; margin-left: 1.25rem; }
        .blog-content li { margin: 0.375rem 0; }
        .blog-content li[data-list="bullet"] { list-style-type: disc; }
        .blog-content li[data-list="ordered"] { list-style-type: decimal; }
        .blog-content h1, .blog-content h2, .blog-content h3 { color: #111827; }
        .blog-content p { color: #374151; white-space: pre-wrap; }
        .blog-content a { color: #2563eb; text-decoration: underline; }
      `}</style> */}
<style>{`
  .blog-content .ql-ui { display: none; }
  .blog-content ol { list-style: decimal; margin-left: 1.25rem; }
  .blog-content ul { list-style: disc; margin-left: 1.25rem; }
  .blog-content li { margin: 0.375rem 0; }
  .blog-content li[data-list="bullet"] { list-style-type: disc; }
  .blog-content li[data-list="ordered"] { list-style-type: decimal; }
  /* Make everything white */
  .blog-content h1, 
  .blog-content h2, 
  .blog-content h3,
  .blog-content p,
  .blog-content blockquote,
  .blog-content strong,
  .blog-content li {
    color: #ffffff;
  }
  .blog-content a { color: #2563eb; text-decoration: underline; }
`}</style>
      {/* Hero Banner Section */}
      {/* <div className='relative bg-[#010101BF] overflow-hidden'>
       
        <div className='absolute inset-0'>
           
          <div className='absolute left-10 top-20 w-16 h-16 bg-white/10 rounded-full'></div>
          <div className='absolute left-20 top-32 w-8 h-8 bg-[#E95923]/20 transform rotate-45'></div>
          <div className='absolute left-32 top-16 w-12 h-12 border-2 border-white/20 rounded-full'></div>

         
          <div className='absolute right-20 top-16 w-20 h-4 bg-[#E95923]/30'></div>
          <div className='absolute right-10 top-28 w-16 h-4 bg-white/20'></div>
          <div className='absolute right-32 top-24 w-2 h-16 bg-white/30'></div>
          <div className='absolute right-16 top-40 w-2 h-12 bg-[#E95923]/40'></div>
        </div>

        <div className='relative z-10 max-w-7xl mx-auto px-4 py-8 md:py-12'>
          <div className='text-center'>
            <h1 className='text-4xl md:text-5xl font-bold text-white mb-4 tracking-tight'>
              {(typeof content.title === "object"
                ? content.title?.value
                : content.title) || "Information Page"}
            </h1>

            
            <div className='flex items-center justify-center text-sm text-gray-300 space-x-4'>
              {content.updatedAt && (
                <div className='flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/20'>
                  <Calendar className='w-4 h-4 mr-2 text-[#E95923]' />
                  <span className='font-medium'>
                    {new Date(
                      typeof content.updatedAt === "object"
                        ? content.updatedAt?.value
                        : content.updatedAt
                    ).toLocaleDateString()}
                  </span>
                </div>
              )}
              {content.author && (
                <div className='flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/20'>
                  <User className='w-4 h-4 mr-2 text-[#E95923]' />
                  <span className='font-medium'>
                    {typeof content.author === "object"
                      ? content.author?.value
                      : content.author}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div> */}
      <div className="w-full bg-primary border-b-2 border-gray px-6 py-4 mb-8 ">
  <div className="max-w-[1600px] mx-auto">
    <div className="flex flex-col gap-3">
      {/* Main Title */}
      <h1>
        <span className="sm:text-xl lg:text-2xl font-bold text-white whitespace-nowrap overflow-hidden text-ellipsis">
          {(typeof content.title === "object"
            ? content.title?.value
            : content.title) || "Information Page"}
        </span>
      </h1>

      {/* Description / Meta Information */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:gap-4">
        {content.updatedAt && (
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/20 text-[10px] sm:text-[14px]">
            <Calendar className="w-4 h-4 mr-2 text-[#E95923]" />
            <span className="font-medium">
              {new Date(
                typeof content.updatedAt === "object"
                  ? content.updatedAt?.value
                  : content.updatedAt
              ).toLocaleDateString()}
            </span>
          </div>
        )}
        {content.author && (
          <div className="flex items-center bg-white/10 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/20 text-[10px] sm:text-[14px]">
            <User className="w-4 h-4 mr-2 text-[#E95923]" />
            <span className="font-medium">
              {typeof content.author === "object"
                ? content.author?.value
                : content.author}
            </span>
          </div>
        )}
      </div>

      {/* Optional Description / Subtitle */}
      {/* {content.description && (
        <p className="text-description text-[10px] sm:text-[14px] font-normal mt-1">
          {typeof content.description === "object"
            ? content.description?.value
            : content.description}
        </p>
      )} */}
    </div>
  </div>
</div>

      {/* Content */}
      <div className='max-w-7xl mx-auto px-4 py-12'>
        <div
          className='bg-card rounded-2xl shadow-xl overflow-hidden
                        hover:shadow-2xl transition-all duration-300'
        >
          {/* Featured Image */}
          {(typeof content.imageUrl === "object"
            ? content.imageUrl?.value
            : content.imageUrl || content.image) &&
            (typeof content.imageUrl === "object"
              ? content.imageUrl?.value
              : content.imageUrl || content.image
            ).trim() !== "" && (
              <div className='aspect-video bg-gradient-to-br from-gray-100 to-gray-200 relative overflow-hidden'>
                <img
                  src={
                    typeof content.imageUrl === "object"
                      ? content.imageUrl?.value
                      : content.imageUrl || content.image
                  }
                  alt={
                    typeof content.title === "object"
                      ? content.title?.value
                      : content.title
                  }
                  className='w-full h-full object-cover transition-transform duration-500 hover:scale-105'
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />

                {/* Subtle gradient overlay */}
                <div className='absolute inset-0 bg-gradient-to-t from-black/30 to-transparent'></div>
              </div>
            )}

          {/* Content Body */}
          <div className='p-10 md:p-16'>
            {(() => {
              const descriptionContent =
                typeof content.description === "object"
                  ? content.description?.value
                  : content.description;
              const cleanContent = descriptionContent
                ?.replace(/<[^>]*>/g, "")
                .trim();

              if (!cleanContent || cleanContent === "") {
                return (
                  <div className='text-center py-12'>
                    <p className='text-white text-lg'>
                      No content available for this page.
                    </p>
                  </div>
                );
              }

              return (
                <div
                  className='blog-content prose prose-2xl max-w-none text-gray-800 leading-relaxed
                             prose-headings:text-gray-900 prose-headings:font-bold prose-headings:mb-6
                             prose-h1:text-3xl prose-h1:font-extrabold prose-h1:text-gray-900 prose-h1:mb-8
                             prose-h2:text-2xl prose-h2:font-bold prose-h2:text-gray-800 prose-h2:mb-6
                             prose-h3:text-xl prose-h3:font-semibold prose-h3:text-gray-800 prose-h3:mb-4
                             prose-p:text-lg prose-p:leading-8 prose-p:mb-6 prose-p:text-gray-700
                             prose-blockquote:border-l-4 prose-blockquote:border-[#E95923] 
                             prose-blockquote:bg-gradient-to-r prose-blockquote:from-[#E95923]/10 prose-blockquote:to-[#E95923]/20
                             prose-blockquote:py-6 prose-blockquote:px-8 prose-blockquote:rounded-r-xl
                             prose-blockquote:font-medium prose-blockquote:text-gray-800 prose-blockquote:not-italic
                             prose-blockquote:shadow-sm prose-blockquote:my-8
                             prose-strong:text-gray-900 prose-strong:font-bold
                             prose-a:text-[#E95923] prose-a:no-underline hover:prose-a:underline prose-a:font-medium
                             prose-ul:space-y-3 prose-ol:space-y-3 prose-ul:my-6 prose-ol:my-6
                             prose-li:text-lg prose-li:leading-8 prose-li:text-gray-700
                             prose-li:marker:text-[#E95923]'
                  dangerouslySetInnerHTML={{ __html: descriptionContent }}
                />
              );
            })()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationPage;
